import { Component, Input, Optional, Self } from "@angular/core";
import { NgControl } from "@angular/forms";
import { FormControlBase } from "../../common/form-control-base/form-control-base";

@Component({
    selector: "waf-text-input",
    templateUrl: "./text-input.component.html",
    inputs: [
        "label",
        "disabled",
        "hideValidationMessages",
        "isReadonlyValue",
        "placeholder",
        "tabindex",
    ],
    standalone: false
})
export class TextInputComponent extends FormControlBase<string> {
  constructor(@Self() @Optional() protected override ngModel: NgControl) {
    super("waf-text-input", ngModel);
  }

  @Input() multiline: boolean = false;

  @Input() minRows = 4;

  @Input() maxLength: number = 255;
}
